"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    tenants: [],
    tenantUsers: [],
    tenantUserRequests: [],
    isFetching: false,
    isFetchingTenant: false,
    isFetchingTenantUsers: false,
    isFetchingUpdateTenant: false,
    isFetchingTenantUserRequests: false,
    isAddingTenant: false,
    showAddTenantModal: false,
    showAddTenantUsersModal: false,
    showEditTenantUserModal: false,
    updateTenantError: false,
    updateTenantErrorMessage: '',
    stripeCard: {},
    isLoadingStripeCard: false,
    stripeInvoices: [],
    stripeUpcomingInvoice: {},
    stripePreviewInvoice: {},
    isLoadingStripeInvoices: false,
    isLoadingStripePreviewInvoice: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case types.TENANTS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: true
      });

    case types.TENANTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false,
        tenants: action.tenants
      });

    case types.TENANTS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false
      });

    case types.SHOW_ADD_TENANT_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Open modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showAddTenantModal: true
      });

    case types.CLOSE_ADD_TENANT_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Close modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showAddTenantModal: false
      });

    case types.SHOW_ADD_TENANT_USERS_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Open add tenant users modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showAddTenantUsersModal: true
      });

    case types.CLOSE_ADD_TENANT_USERS_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Close add tenant users modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showAddTenantUsersModal: false
      });

    case types.SHOW_EDIT_TENANT_USER_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Open edit tenant users modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showEditTenantUserModal: true
      });

    case types.CLOSE_EDIT_TENANT_USER_MODAL:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Close edit tenant users modal'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        showEditTenantUserModal: false
      });

    case types.TENANT_ADD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingTenant: false
      });

    case types.TENANT_ADD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingTenant: true
      });

    case types.TENANT_ADD_SUCCESS:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Add tenant'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingTenant: false,
        showAddTenantModal: false
      });

    case types.TENANT_GET_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenant: true
      });

    case types.TENANT_GET_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenant: false,
        tenant: action.tenant
      });

    case types.TENANT_GET_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenant: false
      });

    case types.TENANT_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUpdateTenant: true,
        updateTenantError: false
      });

    case types.TENANT_UPDATE_SUCCESS:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Edit tenant',
        label: action.tenant.name
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUpdateTenant: false,
        tenant: action.tenant,
        updateTenantError: false
      });

    case types.TENANT_UPDATE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUpdateTenant: false,
        updateTenantError: true,
        updateTenantErrorMessage: action.error
      });

    case types.TENANT_USER_REQUESTS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: true
      });

    case types.TENANT_USER_REQUESTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: false,
        tenantUserRequests: action.tenantUserRequests.filter(function (request) {
          return request.accepted === null;
        })
      });

    case types.TENANT_USER_REQUESTS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: false
      });

    case types.TENANT_USER_REQUEST_ADD_REQUESTED:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Add tenant user'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: true
      });

    case types.TENANT_USER_REQUEST_ADD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false,
        tenantUserRequest: action.tenantUserRequest
      });

    case types.TENANT_USER_REQUEST_ADD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false
      });

    case types.TENANT_USERS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: true
      });

    case types.TENANT_USERS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false,
        tenantUsers: action.tenantUsers
      });

    case types.TENANT_USERS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false
      });

    case types.TENANT_USER_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: true
      });

    case types.TENANT_USER_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false,
        tenantUser: action.tenantUser
      });

    case types.TENANT_USER_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetching: false
      });

    case types.TENANT_USERS_ADD_REQUESTED:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Add tenant users'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: true
      });

    case types.TENANT_USERS_ADD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false,
        showAddTenantUsersModal: false,
        tenantUsers: action.tenantUsers
      });

    case types.TENANT_USERS_ADD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false
      });

    case types.TENANT_USER_REMOVE_REQUESTED:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Remove tenant user'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: true
      });

    case types.TENANT_USER_REMOVE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false,
        removeUserReponse: action.removeUserReponse,
        tenantUsers: state.tenantUsers.filter(function (request) {
          return request.auth0UserId !== action.auth0UserId;
        })
      });

    case types.TENANT_USER_REMOVE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false
      });

    case types.TENANT_USER_UPDATE_REQUESTED:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Edit tenant user'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: true,
        showEditTenantUserModal: false
      });

    case types.TENANT_USER_UPDATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false,
        showEditTenantUserModal: false,
        tenantUser: action.tenantUser,
        tenantUsers: state.tenantUsers.map(function (u) {
          if (u.auth0UserId === action.auth0UserId) {
            return action.tenantUser;
          }

          return u;
        })
      });

    case types.TENANT_USER_UPDATE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUsers: false,
        showEditTenantUserModal: true
      });

    case types.TENANT_USER_REQUEST_UPDATE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: true
      });

    case types.TENANT_USER_REQUEST_UPDATE_SUCCESS:
      _reactGa["default"].event({
        category: 'Tenant',
        action: 'Edit tenant user request'
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: false,
        response: action.response,
        tenantUsers: !action.response ? state.tenantUsers : [action.response].concat(state.tenantUsers),
        tenantUserRequests: state.tenantUserRequests.filter(function (request) {
          return request.id !== action.tenantUserRequestId;
        })
      });

    case types.TENANT_USER_REQUEST_UPDATE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingTenantUserRequests: false
      });

    case types.TENANT_STRIPE_CARD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeCard: true
      });

    case types.TENANT_STRIPE_CARD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeCard: false,
        stripeCard: action.stripeCard
      });

    case types.TENANT_STRIPE_CARD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeCard: false
      });

    case types.TENANT_STRIPE_INVOICES_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: true
      });

    case types.TENANT_STRIPE_INVOICES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: false,
        stripeInvoices: action.stripeInvoices
      });

    case types.TENANT_STRIPE_INVOICES_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: false
      });

    case types.TENANT_STRIPE_UPCOMING_INVOICES_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: true
      });

    case types.TENANT_STRIPE_UPCOMING_INVOICES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: false,
        stripeUpcomingInvoice: action.stripeUpcomingInvoice
      });

    case types.TENANT_STRIPE_UPCOMING_INVOICES_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripeInvoices: false
      });

    case types.TENANT_STRIPE_PREVIEW_INVOICE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripePreviewInvoice: true
      });

    case types.TENANT_STRIPE_PREVIEW_INVOICE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripePreviewInvoice: false,
        stripePreviewInvoice: action.stripePreviewInvoice
      });

    case types.TENANT_STRIPE_PREVIEW_INVOICE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingStripePreviewInvoice: false
      });

    case types.TENANT_STRIPE_UPDATE_CARD:
      return _objectSpread(_objectSpread({}, state), {}, {
        stripeCard: action.stripeCard
      });

    default:
      return state;
  }
};

exports["default"] = _default;